import { useEffect, useState } from "react";
import { http } from "@/lib/api";

// Lote 157 — dados do escritório (equipe e papéis) para os seletores e rótulos das telas. Uma busca por visita.
let cache = null;
let pendente = null;
export function carregarEscritorio(forcar = false) {
  if (cache && !forcar) return Promise.resolve(cache);
  if (!pendente || forcar) {
    pendente = http.get("/escritorio").then((r) => { cache = r.data; return cache; }).catch(() => null).finally(() => { pendente = null; });
  }
  return pendente;
}
// fresco = busca de novo ao abrir a tela (equipe/papéis mudam pouco, mas quem acabou de entrar precisa aparecer já).
export function useEscritorioInfo(ativo = true, fresco = false) {
  const [d, setD] = useState(cache);
  useEffect(() => {
    let vivo = true;
    if (ativo) carregarEscritorio(fresco).then((x) => { if (vivo && x) setD(x); });
    return () => { vivo = false; };
  }, [ativo]);
  return d;
}

// ?de=<dono> para abrir o item de um colega; nada quando o item é meu.
export function comDe(to, donoId, meuId) {
  if (!to || !donoId || donoId === meuId) return to;
  return `${to}${to.includes("?") ? "&" : "?"}de=${encodeURIComponent(donoId)}`;
}

const LS = "iapauta_escopo_pauta";
export function lerEscopo() {
  try { const v = JSON.parse(localStorage.getItem(LS) || "null"); if (v && (v.escopo === "minha" || v.escopo === "escritorio")) return { escopo: v.escopo, responsavel: v.responsavel || "" }; } catch (e) { /* padrão */ }
  return { escopo: "minha", responsavel: "" };
}
export function gravarEscopo(v) { try { localStorage.setItem(LS, JSON.stringify(v)); } catch (e) { /* vale só nesta visita */ } }
